module.exports = __webpack_public_path__ + "static/media/Margarita V.6933f425.jpg";